import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import DetailPageHeader from '../../pages/markets/component/detail-page-header';
import FuturesExternalSearch from '../../pages/markets/component/futures-external-search';
import OpenInterestBreakupOptionsExternal from '../../pages/markets/component/open-interest-breakup-options-external';
import '../../pages/markets/pages/options-external-open-interest-breakup/options-external-open-interest-breakup.m.css';

const OpenInterestBreakupFull = () => {
  const queryClient = new QueryClient();
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        {initialLoading ? (
          <div styleName="initial-loading-container"></div>
        ) : (
          <div styleName="detail-header-container">
            <div className="container">
              <DetailPageHeader />
            </div>
          </div>
        )}

        <div styleName="overall-container">
          <div styleName="search-widget-container" className="container">
            <FuturesExternalSearch />

            <OpenInterestBreakupOptionsExternal widget="break-up" />
          </div>
        </div>
        <div className="container">
          <FuturesAndOptionsFaq />
        </div>
      </>
    </QueryClientProvider>
  );
};

export default OpenInterestBreakupFull;
